'use client';

import { useRef, useState } from 'react';
import { useRouter } from 'next/navigation';

export function useCollapseNavigate(durationMs: number) {
  const router = useRouter();
  const [collapsingKey, setCollapsingKey] = useState<string | null>(null);
  const pendingRef = useRef<string | null>(null);

  const navigate = (href: string, key?: string) => {
    setCollapsingKey(key ?? href);
    pendingRef.current = href;
    window.setTimeout(() => {
      if (pendingRef.current) {
        router.push(pendingRef.current);
        pendingRef.current = null;
      }
    }, durationMs);
  };

  return { collapsingKey, navigate };
}
